import api from '../../../configs/api';
import {
  PRODUCT_TRANSACTION_TYPES_ALL,
  PRODUCT_TRANSACTION_TYPES_DEL,
  PRODUCT_TRANSACTION_TYPES_ERROR,
  PRODUCT_TRANSACTION_TYPES_GET,
  PRODUCT_TRANSACTION_TYPES_LOADING,
  PRODUCT_TRANSACTION_TYPES_POST,
  PRODUCT_TRANSACTION_TYPES_PUT,
} from '../types';

export const productTransactionTypeCreate = (payload) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_TRANSACTION_TYPES_LOADING });
    const { data } = await api.post(
      `${process.env.REACT_APP_API_URL}/product-transaction-type`,
      {
        ...payload,
      },
    );
    dispatch({ type: PRODUCT_TRANSACTION_TYPES_POST, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_TRANSACTION_TYPES_ERROR });
    throw new Error(error);
  }
};

export const productTransactionTypeAll = ({
  name = '',
  size = '',
  page = 1,
  direction = '',
}) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/product-transaction-type?name=${name}&size=${size}&page=${page}&direction=${direction}`,
    );
    if (status === 200) {
      dispatch({ type: PRODUCT_TRANSACTION_TYPES_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_TRANSACTION_TYPES_ERROR });
    throw new Error(error);
  }
};

export const productTransactionTypeGet = (id) => async (dispatch) => {
  try {
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/product-transaction-type/${id}`,
    );
    if (status === 200) {
      dispatch({ type: PRODUCT_TRANSACTION_TYPES_GET, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_TRANSACTION_TYPES_ERROR });
    throw new Error(error);
  }
};

export const productTransactionTypeStateSet = (data) => async (dispatch) => {
  dispatch({ type: PRODUCT_TRANSACTION_TYPES_ALL, payload: data });
};

export const productTransactionTypePut = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_TRANSACTION_TYPES_LOADING });
    const { data } = await api.put(
      `${process.env.REACT_APP_API_URL}/product-transaction-type/${id}`,
      payload,
    );
    dispatch({ type: PRODUCT_TRANSACTION_TYPES_PUT, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_TRANSACTION_TYPES_ERROR });
    throw new Error(error);
  }
};
export const productTransactionTypeDelete = (id) => async (dispatch) => {
  try {
    dispatch({ type: PRODUCT_TRANSACTION_TYPES_LOADING });
    const { data } = await api.delete(
      `${process.env.REACT_APP_API_URL}/product-transaction-type/${id}`,
    );
    dispatch({ type: PRODUCT_TRANSACTION_TYPES_DEL, payload: data });
  } catch (error) {
    console.error(error);
    dispatch({ type: PRODUCT_TRANSACTION_TYPES_ERROR });
    throw new Error(error);
  }
};

export const productTransactionTypeReset = () => async (dispatch) => {
  dispatch({ type: PRODUCT_TRANSACTION_TYPES_LOADING });
};
